import { Link } from 'react-router-dom';
import { trackEvent } from '../lib/tracking';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_BASE, WHATSAPP_GENERIC_MESSAGE } from '../lib/constants';
import { CATALOG_URL } from '@/config/site';

export default function LpFooter() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="max-w-md">
            <img
              src="/media/marca/d74127ff-a8d6-40b5-acfb-37c019b82644_horizontal-branco.png"
              alt="Home Office Premium"
              className="h-7 w-auto object-contain opacity-90 mb-5"
            />
            <p className="text-white/40 text-[13px] leading-relaxed">
              Soluções completas para ambientes corporativos. Projetamos e implantamos mobiliário,
              divisórias, acústica, carpetes e marcenaria — do planejamento à entrega e montagem.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <a
              href={`tel:${PHONE_TEL}`}
              onClick={() => trackEvent('phone_click')}
              className="inline-flex items-center gap-2.5 text-white/70 hover:text-white text-[14px] transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-base"></i>
              {PHONE_DISPLAY}
            </a>
            <a
              href={`${WHATSAPP_BASE}?text=${WHATSAPP_GENERIC_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('whatsapp_projeto_corporativo', { location: 'footer' })}
              className="inline-flex items-center gap-2.5 text-white/70 hover:text-white text-[14px] transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-base"></i>
              Falar no WhatsApp
            </a>
            <a
              href="mailto:ednilsonleocadio@gmail.com"
              className="inline-flex items-center gap-2.5 text-white/70 hover:text-white text-[14px] transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-base"></i>
              ednilsonleocadio@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-[12px] font-light">
            Home Office Premium — Caruaru, Pernambuco
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-white/30 text-[12px] hover:text-white/60 transition-colors font-light">
              Página inicial
            </Link>
            <a
              href={CATALOG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 text-[12px] hover:text-white/60 transition-colors font-light"
            >
              Catálogo
            </a>
            <Link to="/privacidade" className="text-white/30 text-[12px] hover:text-white/60 transition-colors font-light">
              Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}